import { useEffect, useState } from "react";
import { useWordPressPage } from "./useWordPressPage";
import { fetchMediaMap } from "../services/wpPagesApi";
import { collectLandingMediaIds, getAcf } from "../utils/landingAcf";
import { LANDING_PAGE_SLUG } from "../constants/appConfig";

export function useLandingPageData(slug = LANDING_PAGE_SLUG) {
  const { page, loading: pageLoading, error: pageError } = useWordPressPage(slug);
  const [mediaMap, setMediaMap] = useState({});
  const [mediaLoading, setMediaLoading] = useState(false);
  const [mediaError, setMediaError] = useState(null);

  useEffect(() => {
    if (!page) {
      setMediaMap({});
      setMediaLoading(false);
      setMediaError(null);
      return;
    }

    const acf = getAcf(page);
    const ids = collectLandingMediaIds(acf);

    if (ids.length === 0) {
      setMediaMap({});
      setMediaLoading(false);
      return;
    }

    let cancelled = false;
    setMediaLoading(true);
    setMediaError(null);

    fetchMediaMap(ids)
      .then((map) => {
        if (!cancelled) setMediaMap(map);
      })
      .catch((err) => {
        if (!cancelled) setMediaError(err);
      })
      .finally(() => {
        if (!cancelled) setMediaLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [page]);

  const resolveMedia = (imageId) => {
    if (typeof imageId !== "number") return null;
    const media = mediaMap[imageId];
    if (!media) return null;
    if (typeof media === "string") {
      return { url: media, width: null, height: null, alt: "" };
    }
    return media;
  };

  const resolveImage = (imageId) => resolveMedia(imageId)?.url || null;

  return {
    page,
    acf: getAcf(page),
    mediaMap,
    resolveImage,
    resolveMedia,
    loading: pageLoading || mediaLoading,
    error: pageError || mediaError,
  };
}
